import { motion, AnimatePresence } from "framer-motion";

export default function Preloader({ active }) {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-[#0A0F20] flex flex-col items-center justify-center"
          exit={{ opacity: 0, scale: 1.05 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, y: 26, scale: 0.88 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
            className="rounded-2xl bg-gradient-to-br from-white via-[#F7F2E7] to-[#EDE4CF] ring-1 ring-gold/60 shadow-[0_0_90px_rgba(212,175,55,0.35)] px-9 py-6"
          >
            <img src="/assets/logo-emblem.png" alt="Bridge Intell" className="h-20 w-auto" data-testid="preloader-logo" />
          </motion.div>
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.7em" }}
            animate={{ opacity: 1, letterSpacing: "0.32em" }}
            transition={{ duration: 1.2, delay: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="mt-9 font-serif text-sm uppercase text-slate-200"
          >
            Bridge <span className="text-gold">Intell</span>
          </motion.p>
          <motion.div
            aria-hidden
            className="mt-7 h-px bg-gradient-to-r from-transparent via-gold to-transparent"
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: 140, opacity: 1 }}
            transition={{ duration: 1.3, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
